/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { usageGetPeriodUsage } from "../funcs/usageGetPeriodUsage.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { PeriodUsage } from "../models/components/periodusage.js";
import {
  GetPeriodUsageRequest,
  GetPeriodUsageSecurity,
} from "../models/operations/getperiodusage.js";
import { unwrapAsync } from "../types/fp.js";
export type GetPeriodUsageQueryData = PeriodUsage;

export function prefetchGetPeriodUsage(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetPeriodUsageRequest | undefined,
  security?: GetPeriodUsageSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetPeriodUsageQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetPeriodUsageQuery(
  client$: GramCore,
  request?: GetPeriodUsageRequest | undefined,
  security?: GetPeriodUsageSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<GetPeriodUsageQueryData>;
} {
  return {
    queryKey: queryKeyGetPeriodUsage({ gramSession: request?.gramSession }),
    queryFn: async function getPeriodUsageQueryFn(
      ctx,
    ): Promise<GetPeriodUsageQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(usageGetPeriodUsage(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetPeriodUsage(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "usage", "getPeriodUsage", parameters];
}
